import locationsService from '@/api/locationsService'
import { distance, point } from '@turf/turf'
import { MODULE_NAME, MUTATIONS } from '@/store/map'
import { MODULE_NAME as MODULE_NAME_SITE, GETTERS } from '@/store/site/constants'
import { mapMutations, mapGetters } from 'vuex'
import authService, { USER_ROLES } from '@/api/authService'
import layerService from '@/api/layerService'
import customFormatters from '@/filters/customFormatters'
import AdvertsClusterLayer from '@/api/AdvertClusterLayer'
import getMostFrequent from '@/utils/getMostFrequent'
import {
  advertUniqueIconUrl,
  advertSquareUniqueIconUrl,
  advertClusterSmallIconUrl,
  advertClusterMediumIconUrl,
  advertClusterLargeIconUrl,
  advertSquareClusterSmallIconUrl,
  advertSquareClusterMediumIconUrl,
  advertSquareClusterLargeIconUrl,
  ADVERT_TYPES
} from '@/utils/mapUtils'
import { ADVERT_LAYER_ID } from '@/store/map/constants'
import { IconLayer } from '@deck.gl/layers'
import i18n from '@/i18n'

const MARKER_LAYER_ID = 'location_advert_marker'
const iconAdvertUrl = require('@/assets/icons/map/icon-unique-marker-advert.svg')
const iconAdverSquaretUrl = require('@/assets/icons/map/icon-unique-advert-marker-square.svg')

export default {
  name: 'AdvertDetail',
  mixins: [customFormatters],
  components: {
    AvailabilityModal: () => import(/* webpackChunkName: "AvailabilityModal" */ '@/components/availability-modal/AvailabilityModal.vue')
  },
  props: {},
  data () {
    return {
      authData: authService.authData,
      titleScrollReached: false,
      advert: {
        price: 0,
        sizes_available: [],
        formats_available: [],
        shop_related: {},
        costs: {
          month_price: 0,
          production_cost: 0,
          design_cost: 0,
          redesign_cost: 0
        }
      },
      availabilityModal: false,
      deleteModalOpen: false,
      deleteLoading: false,
      slots: [],
      tagType: 'toggle-close',
      backgroundColor: 'var(--colorPrimary)',
      adverts: {
        meta: { loading: true, count: 0 },
        results: []
      }
    }
  },
  computed: {
    ...mapGetters(MODULE_NAME_SITE, {
      backLink: GETTERS.GET_BACK_LINK
    }),
    background () {
      return 'var(--colorPrimaryVeryTransparent)'
    },
    emplacementIsUrl () {
      return /^(http|https)/.test(this.advert.emplacement)
    },
    distanceMeters () {
      if (!this.advert.id) {
        return 0
      }
      const p1 = point([ this.advert.lng, this.advert.lat ])
      const p2 = point([ this.advert.shop_related.lng, this.advert.shop_related.lat ])
      const km = distance(p1, p2, { units: 'kilometers' })
      const meters = km * 1000
      return meters
    },
    activeTag () {
      return this.advert.is_active ? 'Soporte Activo' : 'Soporte No Activo'
    },
    activeTagColor () {
      return this.advert.is_active ? 'var(--colorPrimary)' : 'var(--colorVeryLow)'
    },
    isAdmin () {
      return this.authData.user.role === USER_ROLES.ROOT ||
        this.authData.user.role === USER_ROLES.CENTRAL_ADMIN ||
        this.authData.user.role === USER_ROLES.AGENCY_PATRIMONY
    },
    advertid () {
      return this.$route.params.advertid
    },
    shopid () {
      return this.$route.query.shop
    },
    backLink () {
      return String(this.shopid) !== 'undefined' ? `/map/center-detail/${this.shopid}?tab=competitors` : `/map`
    }
  },
  watch: {
    'advertid': {
      immediate: true,
      handler (id) {
        this.fetchAdvert(id)
        this.fetchNotAvailabilitySlotAdvert(id)
      }
    }
  },
  mounted () {
    this.$refs.scrollContent.addEventListener('scroll', this.onScroll, false)
  },
  beforeDestroy () {
    layerService.removeLayer(ADVERT_LAYER_ID)
    layerService.removeLayer(MARKER_LAYER_ID)
  },
  // beforeRouteLeave (to, from, next) {
  //   if (to.name === 'locations-list' || !to.matched.some(r => r.name === 'map')) {
  //     this[MUTATIONS.RESET_VIEWSTATE]()
  //   }
  //   next()
  // },
  methods: {
    ...mapMutations(MODULE_NAME, [ MUTATIONS.SET_VIEWSTATE, MUTATIONS.RESET_VIEWSTATE, MUTATIONS.FLY_TO ]),
    onScroll () {
      const scrollTop = this.$refs.scrollContent.scrollTop
      this.titleScrollReached = scrollTop >= 60
    },
    fetchAdvert (id) {
      locationsService.getAdvert({ id }).then(advert => {
        advert.advert_type = advert.advert_type.toLowerCase()
        this.advert = { ...advert, price: Number(advert.price) }
        if (!this.advert.costs) {
          this.advert.costs = {
            month_price: 0,
            production_cost: 0,
            design_cost: 0,
            redesign_cost: 0
          }
        }
        this.getAdverts(advert.shop_related.id)
        this.centerMap()
      })
    },
    fetchNotAvailabilitySlotAdvert (id) {
      locationsService.getAdvertAvailabilitySlots(id).then(data => {
        this.slots = data
      })
    },
    centerMap () {
      const { lng, lat } = this.advert
      this[MUTATIONS.FLY_TO]({ latitude: lat, longitude: lng, zoom: 13 })
    },
    drawMarker () {
      layerService.addLayer({
        id: MARKER_LAYER_ID,
        layerType: IconLayer,
        data: [this.advert],
        getPosition: d => [d.lng, d.lat],
        getIcon: (d) => {
          return {
            width: 32,
            height: 32,
            url: d.advert_type === 'producto'
              ? iconAdvertUrl
              : iconAdverSquaretUrl,
            anchorY: 32
          }
        },
        getSize: 48
      })
    },
    updateAvailability () {
      this.availabilityModal = true
    },
    closeAvailabilityModal (refetch = false) {
      this.availabilityModal = false
      if (refetch) {
        this.fetchNotAvailabilitySlotAdvert(this.advert.id)
      }
    },
    onItemSelected (item) {
      locationsService.removeAdvertAvailabilitySlots(this.advert.id, item.id).then(data => {
        this.fetchNotAvailabilitySlotAdvert(this.advert.id)
      })
    },
    async deleteAdvert () {
      try {
        await locationsService.deleteAdvert(this.advert.id)
        this.$router.push(this.backLink)
      } catch (err) {
        // eslint-disable-next-line
        console.error('[advert-detail.js] Error deleting advert', err)
      }
      this.deleteLoading = false
      this.deleteModalOpen = false
    },
    async getAdverts (shopId, page) {
      // TODO: pagination?
      this.adverts.meta.loading = true
      try {
        const params = {
          shop_related: shopId,
          page,
          meta: 1,
          page_size: 1000
        }
        const { meta, results } = await locationsService.getAdverts(params)
        this.adverts.meta = meta
        if (page > 0) {
          this.adverts.results = this.adverts.results.concat(results).sort((a, b) => a.address.localeCompare(b.address))
        } else {
          this.adverts.results = results.sort((a, b) => a.address.localeCompare(b.address))
        }
        this.filteredAdverts = this.adverts
        this.drawAdvertsLayer()
        this.drawMarker()
      } catch (err) {
        // eslint-disable-next-line
        console.error("[center-detail.js] Error fetching adverts", err);
      }
      this.adverts.meta.loading = false
    },
    drawAdvertsLayer () {
      layerService.addLayer({
        id: ADVERT_LAYER_ID,
        data: this.adverts.results,
        layerType: AdvertsClusterLayer,
        getPath: d => {
          return [
            [d.properties.shop_related.lng, d.properties.shop_related.lat],
            [...d.geometry.coordinates]
          ]
        },
        sizeScale: 32,
        textSizeScale: 20,
        pickable: true,
        getPosition: d => [d.lng, d.lat],
        getIcon: (d) => {
          const type = getMostFrequent(d.properties.advert_type.split('-'))
          const count = d.properties.point_count
          const advertIcon = count > 0 && count <= 10 ? advertClusterSmallIconUrl : count > 10 && count <= 99 ? advertClusterMediumIconUrl : count > 99 ? advertClusterLargeIconUrl : advertUniqueIconUrl
          const advertSquareIcon = count > 0 && count <= 10 ? advertSquareClusterSmallIconUrl : count > 10 && count <= 99 ? advertSquareClusterMediumIconUrl : count > 99 ? advertSquareClusterLargeIconUrl : advertSquareUniqueIconUrl

          return {
            width: 40,
            height: 40,
            url: type === ADVERT_TYPES.PRODUCT
              ? advertIcon
              : advertSquareIcon
          }
        },
        getTooltip ({ object }) {
          const count = object.properties.point_count
          const label = object.properties.address
          const type = object.properties.advert_id || getMostFrequent(object.properties.advert_type.split('-'))
          const text = count > 1 ? `${count} ${i18n.t('ADVERTS')}` : label
          const html = `
            <div>
              <p>
                <small style="font-size: 80%; font-weight: 600">${type}</small>
              </p>
              <p>${text}</p>
            </div>
          `
          const style = {
            'background': 'var(--colorNegative)',
            color: 'var(--colorHigh)'
          }
          return { html, style, className: 'map-popup-white' }
        },
        onClick: ({ object, coordinate }) => {
          if (!object) {
            return
          }
          const { id, cluster } = object.properties
          if (cluster) {
            const [longitude, latitude] = coordinate
            this[MUTATIONS.FLY_TO]({
              longitude,
              latitude,
              zoom: this.viewState.zoom + 1
            })
          } else {
            this.sidebarExpanded = true
            this.$router.push({ name: 'advert-detail', params: { advertid: id } })
          }
        }
      })
    }
  }
}
